module.exports = __webpack_public_path__ + "static/media/btc_logo.dcbf5042.svg";